<template>
  <w-icon-wrapper
    :height='18'
    :width='24'
    icon-name='work-container-icon'
    view-box='0 0 24 18'
  >
    <g
      id="_87_Kontainer_Icon"
      data-name="87 Kontainer_Icon"
      transform="translate(0 -4.803)"
    >
      <path
        id="Pfad_55839"
        data-name="Pfad 55839"
        d="M0,4.8v18H24V4.8Zm2,2H5v14H2Zm5,0h4v14H7Zm6,0h4v14H13Zm9,14H19V6.8h3Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconContainer' };
</script>
